/* unplugin-vue-components disabled */import script from "./DictionaryItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./DictionaryItem.vue?vue&type=script&setup=true&lang=ts"

import "./DictionaryItem.vue?vue&type=style&index=0&id=71fe41e6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71fe41e6"]])

export default __exports__